module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-TW":{"description_with_reward":"針對以下關鍵字撰寫評論，經AI分析後將發放額外回饋。","description_wihout_reward":"請嘗試針對以下關鍵字進行撰寫。"}}')
  delete Component.options._Ctor
}
